import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isGlobal',
    standalone: false
})
export class IsGlobalPipe implements PipeTransform {
  transform(categories: any[], isGlobal: boolean) {
    return categories.filter(category => category.isGlobal === isGlobal);
  }
}